import React, { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { HStack, Text, VStack } from 'components/ui';
import { CheckIcon } from 'lucide-react';

const StepCircle = ({
  step,
  complete,
}: {
  step?: number;
  complete?: boolean;
}) => {
  return (
    <Box
      w={30}
      h={30}
      flexShrink={0}
      alignContent={'center'}
      justifyItems={'center'}
      borderRadius={'full'}
      bg={complete ? 'primary.600' : 'secondary.500'}
    >
      <Text
        color={'white'}
        lineHeight={'21px'}
        fontWeight={700}
        fontSize={'14px'}
      >
        {complete ? <CheckIcon size={20} /> : step}
      </Text>
    </Box>
  );
};

type StepRowProps = {
  step?: number;
  title?: string;
  body?: string;
  children?: ReactNode;
  complete?: boolean;
};

export const ThankYouStepRow = ({
  step,
  title,
  body,
  complete,
  children,
}: StepRowProps) => {
  return (
    <HStack gap={4} alignItems={!body && !children ? 'center' : undefined}>
      <StepCircle step={step} complete={complete} />
      <VStack gap={1} width={'100%'}>
        {title && (
          <Text
            fontFamily={'body'}
            fontSize={'15.5px'}
            fontWeight={700}
            color={'secondary.500'}
          >
            {title}
          </Text>
        )}
        {body && (
          <Text
            fontFamily={'body'}
            fontSize={'13.5px'}
            fontWeight={400}
            color={'#2B4A52'}
          >
            {body}
          </Text>
        )}
        {children}
      </VStack>
    </HStack>
  );
};
